module.exports = __webpack_public_path__ + "assets/images/figurine_diego.72fbe86.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/figurines/figurine_diego.png
// module id = 350
// module chunks = 1